import React, { useContext, useEffect, useState } from 'react'
import TotalRevenue from '../../assets/img/svg/total-revenue.svg'
// import Refunds from '../../assets/img/svg/refunds.svg'
import Properties from '../../assets/img/svg/properties.svg'
import NewClient from '../../assets/img/svg/people.svg'
import TableView from '../../component/common/tableView'
import { itemRender } from '../../helper/paginationfunction'
import { Dropdown } from 'react-bootstrap'
import { DateRange } from 'react-date-range'
import { Button } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import {
  getBestCleanersReport,
  getBestPropertyReport,
  getGeneralMatrixReport,
  getRegionWiseInActiveReport,
  getRegionWiseReport
} from '../../redux/slices/reportSlice'
import { formatAmount, getDayStartAndEndTimestamps, getTimeStamp } from '../../helper/function'
import { SpinnerContext } from '../../context/spinnerContext'
import RatingDisplay from '../../component/rating'

const General = () => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const { allRegionReport, allBestCleaners, allBestProperty, reportGeneralMatrix, allRegionInActiveReport } = useSelector((state) => state.report)

  // States
  const [cleanersPage, setCleanersPage] = useState(1)
  const [cleanersPageSize, setCleanersPageSize] = useState(10)
  const [propertiesPage, setPropertiesPage] = useState(1)
  const [propertiesPageSize, setPropertiesPageSize] = useState(10)
  const [showDatePicker, setShowDatePicker] = useState(false)

  const [regionActivePage, setRegionActivePage] = useState(1)
  const [regionActivePageSize, setRegionActivePageSize] = useState(10)

  const [regionInActivePage, setRegionInActivePage] = useState(1)
  const [regionInActivePageSize, setRegionInActivePageSize] = useState(10)

  const [timeline, setTimeline] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ])
  const [range, setRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ])

  const resetPagination = () => {
    setCleanersPage(1)
    setCleanersPageSize(10)
    setPropertiesPage(1)
    setPropertiesPageSize(10)
    setRegionActivePage(1)
    setRegionActivePageSize(10)
    setRegionInActivePage(1)
    setRegionInActivePageSize(10)
  }

  // Utility Functions
  const clearSelection = () => {
    setRange([{ startDate: null, endDate: null, key: 'selection' }])
    setTimeline([{ startDate: new Date(), endDate: new Date(), key: 'selection' }])
    setShowDatePicker(false)
    resetPagination()
  }

  const toggleDatePicker = () => {
    setShowDatePicker((prev) => !prev)
  }

  const handleSelect = (ranges) => {
    setRange([ranges?.selection])
    setTimeline([ranges?.selection])
    setShowDatePicker(false)
    resetPagination()
  }

  const isValidDate = (date) => date && !isNaN(date)

  // Fetch cleaner report
  useEffect(() => {
    const fetchCleanerReport = async () => {
      const start_date = getTimeStamp(range[0]?.startDate)
      const end_date = getTimeStamp(range[0]?.endDate)

      const { endOfDayTimestamp } = getDayStartAndEndTimestamps(end_date)

      const cleanerPayload = {
        page: cleanersPage,
        limit: cleanersPageSize,
        ...(isValidDate(start_date) && isValidDate(end_date) && { from_date: start_date, to_date: endOfDayTimestamp })
      }

      try {
        changeLoader(true)
        await dispatch(getBestCleanersReport(cleanerPayload))
      } catch (error) {
        console.error('Error fetching cleaner report:', error)
      } finally {
        changeLoader(false)
      }
    }

    fetchCleanerReport()
  }, [cleanersPage, cleanersPageSize, range])

  // Fetch property report
  useEffect(() => {
    const fetchPropertyReport = async () => {
      const start_date = getTimeStamp(range[0]?.startDate)
      const end_date = getTimeStamp(range[0]?.endDate)

      const { endOfDayTimestamp } = getDayStartAndEndTimestamps(end_date)

      const propertyPayload = {
        page: propertiesPage,
        limit: propertiesPageSize,
        ...(isValidDate(start_date) && isValidDate(end_date) && { from_date: start_date, to_date: endOfDayTimestamp })
      }

      try {
        changeLoader(true)
        await dispatch(getBestPropertyReport(propertyPayload))
      } catch (error) {
        console.error('Error fetching property report:', error)
      } finally {
        changeLoader(false)
      }
    }

    fetchPropertyReport()
  }, [propertiesPage, propertiesPageSize, range])

  useEffect(() => {
    const fetchGeneralMatrixReport = () => {
      const start_date = getTimeStamp(range[0]?.startDate)
      const end_date = getTimeStamp(range[0]?.endDate)

      const { endOfDayTimestamp } = getDayStartAndEndTimestamps(end_date)

      const generalMatrixPayload = {
        ...(isValidDate(start_date) && isValidDate(end_date) && { from_date: start_date, to_date: endOfDayTimestamp })
      }

      changeLoader(true)
      dispatch(getGeneralMatrixReport(generalMatrixPayload))
      changeLoader(false)
    }

    fetchGeneralMatrixReport()
  }, [range])

  useEffect(() => {
    const fetchRegionActiveReport = async () => {
      const start_date = getTimeStamp(range[0]?.startDate)
      const end_date = getTimeStamp(range[0]?.endDate)

      const { endOfDayTimestamp } = getDayStartAndEndTimestamps(end_date)

      const payload = {
        is_active: true,
        page: regionActivePage,
        limit: regionActivePageSize,
        ...(isValidDate(start_date) && isValidDate(end_date) && { from_date: start_date, to_date: endOfDayTimestamp })
      }

      try {
        changeLoader(true)
        await dispatch(getRegionWiseReport(payload))
      } catch (error) {
        console.error('Error fetching property report:', error)
      } finally {
        changeLoader(false)
      }
    }

    fetchRegionActiveReport()
  }, [regionActivePage, regionActivePageSize, range])

  useEffect(() => {
    const fetchRegionActiveReport = async () => {
      const start_date = getTimeStamp(range[0]?.startDate)
      const end_date = getTimeStamp(range[0]?.endDate)

      const { endOfDayTimestamp } = getDayStartAndEndTimestamps(end_date)

      const payload = {
        is_active: false,
        page: regionInActivePage,
        limit: regionActivePageSize,
        ...(isValidDate(start_date) && isValidDate(end_date) && { from_date: start_date, to_date: endOfDayTimestamp })
      }

      try {
        changeLoader(true)
        await dispatch(getRegionWiseInActiveReport(payload))
      } catch (error) {
        console.error('Error fetching property report:', error)
      } finally {
        changeLoader(false)
      }
    }

    fetchRegionActiveReport()
  }, [regionInActivePage, regionInActivePageSize, range])

  // Pagination Handlers
  const handleCleanersPagination = (page, pageSize) => {
    setCleanersPage(page)
    setCleanersPageSize(pageSize)
  }

  const handlePropertiesPagination = (page, pageSize) => {
    setPropertiesPage(page)
    setPropertiesPageSize(pageSize)
  }

  const handleRegionActivePagination = (page, pageSize) => {
    setRegionActivePage(page)
    setRegionActivePageSize(pageSize)
  }

  const handleRegionInActiveagination = (page, pageSize) => {
    setRegionInActivePage(page)
    setRegionInActivePageSize(pageSize)
  }

  // Table Columns
  const activeColumns = [
    { title: 'Region', dataIndex: 'regions', key: 'regions' },
    {
      title: 'Total Active Revenue',
      dataIndex: 'totalRevenue',
      key: 'totalRevenue',
      render: (data) => {
        return <div>{formatAmount(data) || 0}</div>
      }
    },
    { title: 'Active Jobs', dataIndex: 'jobs', key: 'jobs' },
    { title: 'Total Active Client', dataIndex: 'totalClients', key: 'totalClients' },
    { title: 'Total Active Properties', dataIndex: 'totalProperties', key: 'totalProperties' },
    { title: 'Total Active Cleaners', dataIndex: 'totalCleaners', key: 'totalCleaners' }
  ]

  const InActiveColumn = [
    { title: 'Region', dataIndex: 'regions', key: 'regions' },
    {
      title: 'Total InActive Revenue',
      dataIndex: 'totalRevenue',
      key: 'totalRevenue',
      render: (data) => {
        return <div>{formatAmount(data) || 0}</div>
      }
    },
    { title: 'InActive Jobs', dataIndex: 'jobs', key: 'jobs' },
    { title: 'Total InActive Client', dataIndex: 'totalClients', key: 'totalClients' },
    { title: 'Total InActive Properties', dataIndex: 'totalProperties', key: 'totalProperties' },
    { title: 'Total InActive Cleaners', dataIndex: 'totalCleaners', key: 'totalCleaners' }
  ]
  const cleanerColumns = [
    { title: 'Best Cleaner', dataIndex: 'cleanersName', key: 'cleanersName' },
    {
      title: 'Jobs',
      dataIndex: 'jobs',
      key: 'jobs'
    },
    {
      title: 'Rating',
      dataIndex: 'rating',
      key: 'rating',
      render: (rating) => <RatingDisplay selectedValue={rating} />
    }
  ]

  const propertyColumns = [
    { title: 'Best Properties', dataIndex: 'propertyName', key: 'propertyName' },
    { title: 'Cleanings', dataIndex: 'cleanings', key: 'cleanings' }
  ]

  return (
    <div>
      {/* Dashboard Topbar */}
      <div className="deshboard_topbar">
        <div className="schedule_sec dropdown_with_btn">
          <div className="regions_sec">
            <Dropdown show={showDatePicker} onToggle={toggleDatePicker}>
              <Dropdown.Toggle className="dropdown_opction_one" id="date-range-dropdown">
                Date Range
              </Dropdown.Toggle>
              <Dropdown.Menu className="date_picker_dropdown">
                {showDatePicker && (
                  <div className="date_picker_box_filter_div">
                    <DateRange
                      editableDateInputs
                      onChange={handleSelect}
                      moveRangeOnFirstSelection={false}
                      showSelectionPreview={true}
                      ranges={timeline}
                      className="date_range_selector"
                      direction="vertical"
                    />
                  </div>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="regions_sec">
            <Button className="btn btn-primary btn-small circle_btn" onClick={clearSelection}>
              Clear Selection
            </Button>
          </div>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="row deshboard_subdatasec_topbar mb-4 row_gap_div">
        {[
          { title: 'Total Revenue', value: `${formatAmount(reportGeneralMatrix?.totalRevenue) || 0}`, img: TotalRevenue },
          { title: 'Cleaners', value: reportGeneralMatrix?.totalCleaners, img: NewClient },
          { title: 'New Clients', value: reportGeneralMatrix?.totalClients, img: NewClient },
          { title: 'New Properties', value: reportGeneralMatrix?.totalProperties, img: Properties }
        ].map((card, index) => (
          <div key={index} className="col-md-6 col-lg-6 col-xl-3 subdatasec_topbar_box">
            <div className="subdatasec_topbar">
              <div>
                <h4 className="cleanings_month_subtext mb-1">{card.title}</h4>
                <h4 className="cleanings_month_text mb-0 fw-bolder">{card.value}</h4>
              </div>
              <div className="deshboard_topbar_imgsec">
                <img className="cleaning_tool_img" src={card.img} alt="icon" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Region Data Table */}
      <div className="row mb-3 row-gap-3">
        <div className="col-sm-9">
          <div className="table-card-div">
            <div className="card-table">
              <div className="card-body purchase">
                <div className="table-responsive table-hover">
                  <TableView
                    columns={activeColumns}
                    dataSource={allRegionReport?.data || []}
                    paginationConfig={{
                      itemRender,
                      total: allRegionReport?.totalRecords || 0,
                      current: regionActivePage,
                      pageSize: regionActivePageSize,
                      onChange: handleRegionActivePagination
                    }}
                    scroll={allRegionReport?.data?.length > 0 ? { x: true } : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3">
          <div className="table-card-div text-center h-100 d-flex align-items-center justify-content-center">
            <div className="customer_retention_cls">
              <h4>Customer Retention</h4>
              <h3>65.96%</h3>
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="table-card-div">
            <div className="card-table">
              <div className="card-body purchase">
                <div className="table-responsive table-hover">
                  <TableView
                    columns={InActiveColumn}
                    dataSource={allRegionInActiveReport?.data || []}
                    paginationConfig={{
                      itemRender,
                      total: allRegionInActiveReport?.totalRecords || 0,
                      current: regionInActivePage,
                      pageSize: regionInActivePageSize,
                      onChange: handleRegionInActiveagination
                    }}
                    scroll={allRegionInActiveReport?.data?.length > 0 ? { x: true } : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Cleaner and Properties Tables */}
      <div className="row row-gap-3">
        <div className="col-sm-7">
          <div className="table-card-div">
            <div className="card-table">
              <div className="card-body purchase">
                <div className="table-responsive table-hover">
                  <TableView
                    columns={cleanerColumns}
                    scroll={allBestCleaners?.length > 0 ? { x: true } : false}
                    dataSource={allBestCleaners?.report || []}
                    paginationConfig={{
                      itemRender,
                      total: allBestCleaners?.totalRecords || 0,
                      current: cleanersPage,
                      pageSize: cleanersPageSize,
                      onChange: handleCleanersPagination
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-5">
          <div className="table-card-div">
            <div className="card-table">
              <div className="card-body purchase">
                <div className="table-responsive table-hover">
                  <TableView
                    columns={propertyColumns}
                    scroll={allBestProperty?.length > 0 ? { x: true } : false}
                    dataSource={allBestProperty?.report || []}
                    paginationConfig={{
                      itemRender,
                      total: allBestProperty?.totalRecords || 0,
                      current: propertiesPage,
                      pageSize: propertiesPageSize,
                      onChange: handlePropertiesPagination
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default General
